import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Button component for connecting/disconnecting ranks between consecutive options
 * Shows "Connect Ranks" when options are separate, "Disconnect Ranks" when connected
 */
const ConnectRanksButton = ({
    isConnected,
    onToggleConnection,
    upperOptionId,
    lowerOptionId,
    disabled = false
}) => {
    const { t } = useTranslation(['voting']);

    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onToggleConnection(upperOptionId, lowerOptionId, !isConnected);
    };

    const handleMouseDown = (event) => {
        // Prevent drag from starting when mouse down occurs on button
        event.stopPropagation();
    };

    const handlePointerDown = (event) => {
        // Prevent drag from starting when pointer down occurs on button
        event.stopPropagation();
    };

    return (
        <button
            type="button"
            className={`connect-ranks-button ${isConnected ? 'connected' : 'disconnected'}`}
            onClick={handleClick}
            onMouseDown={handleMouseDown}
            onPointerDown={handlePointerDown}
            disabled={disabled}
            title={isConnected ? t('voting:actions.disconnectRanks') : t('voting:actions.connectRanks')}
            aria-label={isConnected ? t('voting:actions.disconnectRanks') : t('voting:actions.connectRanks')}
        >
            {isConnected ? t('voting:actions.disconnectRanks') : t('voting:actions.connectRanks')}
        </button>
    );
};

export default ConnectRanksButton;